import { render, staticRenderFns } from "./DeviceStatis.vue?vue&type=template&id=029dae3f&scoped=true&"
import script from "./DeviceStatis.vue?vue&type=script&lang=js&"
export * from "./DeviceStatis.vue?vue&type=script&lang=js&"
import style0 from "./DeviceStatis.vue?vue&type=style&index=0&id=029dae3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029dae3f",
  null
  
)

export default component.exports